import React, { useEffect, useState } from 'react';
import { AuthProvider, useAuth } from './AuthContext';
import PageLogin from './login/PageLogin';
import Main from './components/Main';
import { auth } from './firebase';
import LoadingScreen from './components/Common/LoadingScreen';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

const AppContent = ({ presentUser, onboard, gotoOnboard }) => {
  const { token, isLoading } = useAuth();

  // If token exists and we are currently validating it, show workspace loading screen
  if (token && isLoading) {
    return <LoadingScreen title="Personalizing your Workspace" subtitle="Syncing your records and permissions..." />;
  }

  // To be authenticated, BOTH Firebase user (presentUser) AND valid backend token are required
  const isAuthenticated = Boolean(presentUser && token);

  if (!isAuthenticated || onboard) {
    return <PageLogin gotoOnboard={gotoOnboard} />;
  }

  return <Main presentUser={presentUser} />;
};

function App() {
  const [presentUser, setPresentUser] = useState(null);
  const [onboard, setOnboard] = useState(false);
  const [isAuthLoading, setIsAuthLoading] = useState(true); // Track Firebase auth state

  useEffect(() => {
    let logoutTimer;
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setPresentUser({
          uid: user.uid,
          email: user.email,
        });
        logoutTimer = setTimeout(() => {
          auth.signOut();
        }, 60 * 60 * 1000);
      } else {
        setPresentUser(null);
        clearTimeout(logoutTimer);
      }
      setIsAuthLoading(false); // Auth state is resolved
    });

    return () => {
      unsubscribe();
      clearTimeout(logoutTimer);
    };
  }, []);

  const gotoOnboard = (newValue) => {
    setOnboard(newValue);
  };

  // Show a loading indicator while Firebase auth is initializing
  if (isAuthLoading) {
    return <LoadingScreen />;
  }

  return (
    <AuthProvider presentUser={presentUser}>
      <div className="App">
        <ToastContainer 
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <AppContent 
          presentUser={presentUser} 
          onboard={onboard} 
          gotoOnboard={gotoOnboard} 
        />
      </div>
    </AuthProvider>
  );
}

export default App;